'use client'

import BaseAPI from "../api/api";
import { FrontApi } from "../api/front-api/front.api";

import { AxiosResponse } from "axios";

export enum TYPE_SHARE_LIKE {
    LIKE = 'LIKE',
    DISLIKE = 'DISLIKE',
    SHARE = 'SHARE',
}

export enum SOCIAL_MEDIA_TYPE {
    LINE = 'LINE',
    FACEBOOK = 'Facebook',
    X = 'X',
}

class FrontContentApi extends BaseAPI {
    static likeSharedDailyWarning(id_content: number, type_share_like: string, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`content-daily-warning/${id_content}/like-share`, undefined, {
            params: {
                type_share_like,
                social_media
            }
        })
    }
    static sharedDailyWarning(id_content: number, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`content-daily-warning/${id_content}/share`, {
            params: {
                type_share_like: "share",
                social_media
            }
        })
    }
    static likeSharedSpsTbt(id_content: number, type_share_like: string, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`content-sps/${id_content}/like-share`, undefined, {
            params: {
                type_share_like,
                social_media
            }
        })
    }
    static sharedContentSpsTbt(id_content: number, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`content-sps/${id_content}/share`, {
            params: {
                type_share_like: "share",
                social_media
            }
        })
    }
    static likeSharedArticle(id_article: number, type_share_like: string, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`article/${id_article}/like-share`, undefined, {
            params: {
                type_share_like,
                social_media
            }
        })
    }
    static sharedArticle(id_article: number, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`article/${id_article}/share`, {
            params: {
                type_share_like: "share",
                social_media
            }
        })
    }
    static likeSharedJournal(id_journal: number, type_share_like: string, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`journal/${id_journal}/like-share`, undefined, {
            params: {
                type_share_like,
                social_media
            }
        })
    }
    static sharedJournal(id_journal: number, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`journal/${id_journal}/share`, {
            params: {
                type_share_like: "share",
                social_media
            }
        })
    }
    static likeSharedDocumentary(id_documentary: number, type_share_like: string, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`documentary/${id_documentary}/like-share`, undefined, {
            params: {
                type_share_like,
                social_media
            }
        })
    }
    static sharedDocumentary(id_documentary: number, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`documentary/${id_documentary}/share`, {
            params: {
                type_share_like: "share",
                social_media
            }
        })
    }
    static likeGallery(id_gallery: number, type_share_like: string, social_media?: string): Promise<AxiosResponse> {
        return this.api.patch(`front-api/gallery/${id_gallery}/like-share`, undefined, {
            params: {
                type_share_like,
                social_media
            }
        })
    }
}

export const likeContent = async (id: number, type: "LIKE" | "DISLIKE" | "SHARED", mode: "CONTENT" | "GALLERY", callback: (status: boolean, id_content: number, type: "LIKE" | "DISLIKE" | "SHARED") => void, social_media?: string) => {
    if (mode === 'CONTENT') {
        const response = await FrontApi.likeSharedContent(id, {
            type_share_like: type === 'LIKE' ? TYPE_SHARE_LIKE.LIKE : type === 'DISLIKE' ? TYPE_SHARE_LIKE.DISLIKE : TYPE_SHARE_LIKE.SHARE,
        });
        if (type === 'SHARED') {
            await FrontApi.likeSharedContent(id, {
                type_share_like: 'SHARE',
            }).catch((err) => console.log(err))
        }
        if (response.status < 300) {
            return callback(true, id, type)
        } else {
            return callback(false, id, type)
        }
    }
    else if (mode === 'GALLERY') {
        const response = await FrontApi.likeSharedGallery(id, {
            type_share_like: type === 'LIKE' ? TYPE_SHARE_LIKE.LIKE : type === 'DISLIKE' ? TYPE_SHARE_LIKE.DISLIKE : TYPE_SHARE_LIKE.SHARE
        });
        // if (type == 'SHARED' && social_media) {
        //     await FrontApi.likeSharedGallery(id, {
        //         type_share_like: "SHARE",
        //         social_media: social_media as SOCIAL_MEDIA_TYPE
        //     });
        // }
        if (response.status < 300) {
            return callback(true, id, type)
        } else {
            return callback(false, id, type)
        }
    }
    // else if (mode === 'DOCUMENTARY') {
    //     const response = await FrontContentApi.likeSharedDocumentary(id, type === 'LIKE' ? TYPE_SHARE_LIKE.LIKE : type === 'DISLIKE' ? TYPE_SHARE_LIKE.DISLIKE : TYPE_SHARE_LIKE.SHARE);
    //     if (type === 'SHARED') {
    //         await FrontContentApi.sharedDocumentary(id, social_media);
    //     }
    //     if (response.status < 300) {
    //         return callback(true, id, type)
    //     } else {
    //         return callback(false, id, type)
    //     }
    // }
}

